// Fund
import Fund from '@/app/views/Fund.vue';

export default {
  path: '/fund',
  name: 'fund',
  component: Fund,
  meta: { requiresAuth: true, requiresStore: true },
  children: [
    {
      path: 'information',
      name: 'fund-information',
      meta: { requiresSubscription: true, app: 'TOOLKIT' },
      component: () => import(/* webpackChunkName: "fund-information" */ '@/app/views/fund/Fund.vue'),
    },
    {
      path: 'review',
      name: 'fund-review',
      component: () => import(/* webpackChunkName: "fund-review" */ '@/app/views/fund/Review.vue'),
    },
  ],
};
